import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { KeyboardArrowLeft, KeyboardArrowRight, ArrowRightSharp } from '@material-ui/icons';
import "./style.scss";
import MyModal from 'components/MyModal';
import MyBadges from 'components/MyBadges';

import * as no_notifiations from 'images/no-alarm.png'
import NewNotification from 'services/new_notification-request';
import { useUser } from 'models';

export default function CardTab({title, list, load, xs, md, type}){
  const [ n, set_n ] = useState(0);
  const [ enable_transition, set_enable_transition ] = useState(false);
  const [ show_modal, set_show_modal ] = useState(false);
  const [ force_show_modal, set_force_show_modal ] = useState([]);
  const [ _list, _set_list] = useState([]);
  const [ _list_data, _set_list_data] = useState([]);

  const user = useUser();

  const hasMoreThenOneResaleCompany = () => {
    return user.companies.filter(c => c.company_type_id === 2).length > 1
  }

  useEffect(()=>{
    if(!load){
      setTimeout(()=>{
        set_enable_transition(true);
      },5000);
      set_force_show_modal([..._list])
    }
  },[load, _list])

  useEffect(()=>{
    _set_list_data(list.filter(a=>a.force==false))

    let l = JSON.parse(localStorage.getItem("Elite:ignoreNotification")??"[]");
    _set_list(old=>{
      let a = list.filter(a=>{
        return a.force==true && l.indexOf(a.notification_id) == -1
      });
      if(a.length != old.length || JSON.stringify(a.map(d=>({...d, content:null}))) != JSON.stringify(old.map(d=>({...d, content:null})))){
        return a;
      }
      return old;
    });
  },[list])

  function setRead(id){
    // if(!!localStorage.getItem("Elite:company") || hasMoreThenOneResaleCompany() ){
    //   return
    // }
    // NewNotification.setRead(id).then((d)=>{
    //   console.log(d)
    // })
  }

  return (
    <>
      <Col xs={xs} md={md} className='mb-2 pl-1 pr-1'>
        <Card.Body className="card-dashboard shadow bg-white rounded w-100 p-3" style={{position:"relative", minHeight:"225px"}}>
          <Row style={{fontWeight:"bold"}}>
            <Col className="card-tab-title">{title}</Col>
            <Col xs="auto" style={{color:"#FBAF43"}}>
              {load?<></>:(
                <>
                  <KeyboardArrowLeft className={'card-tab-side'+(n<=0?" disabled":"")} onClick={()=>{
                    if(n > 0){
                      set_n(n-1);
                    }
                  }}/>
                  <label style={{fontSize: "small",fontWeight: "500"}}>{` ${n+1}/${_list_data.length} `}</label>
                  <KeyboardArrowRight className={'card-tab-side'+(n>=_list_data.length-1?" disabled":"")} onClick={()=>{
                    if(n < _list_data.length-1){
                      set_n(n+1)
                    }
                  }}/>
                </>
              )}
            </Col>
          </Row>
          <div className="card-tab-area-slide">
            {load?(
              <div style={{textAlign:"center", padding:"1rem"}}>
                <Spinner animation="border"/>
              </div>
            ):(
              <div className="card-tab-list-slide" style={{width: `calc(100% * ${_list_data.length==0?1:_list_data.length})`, marginLeft: `calc(-100% * ${n})`, transition:(enable_transition?".3s":"")}}>
                {_list_data.length > 0 ? (<>
                  {_list_data.map((item, key)=>{
                    return (
                      <div className="card-tab-item-slide" key={key} style={{width: `calc(100% / ${_list_data.length})`}}>
                        <div style={{marginBottom: ".3rem"}}>{item.title}</div>
                        <div>{item.content}</div>
                        <Row className="justify-content-between align-items-center mt-3">
                          <Col xs="auto">
                            {item.tag?
                            <MyBadges variant={(item.tag.variant??"primary")}>{item.tag.text}</MyBadges>
                            :<></>}
                          </Col>
                          <Col xs="auto">
                            <div className="card-tab-item-slide-more" onClick={()=>{set_show_modal(true)}}>Saiba mais <ArrowRightSharp/></div>
                          </Col>
                        </Row>
                        
                      </div>
                    )
                  })}
                </>):(<div className='text-center m-3 d-flex flex-column align-items-center'>
                  <img src={no_notifiations} width='50' /> 
                  <span className='font-weight-bold'>{type == 1 ? "Sem Notificações..." : "Sem Avisos..."}</span>
                </div>)}
              </div>
            )}
          </div>
        </Card.Body>
      </Col>
      <MyModal 
        show={show_modal || force_show_modal.length} 
        onHide={()=>{
          set_show_modal(false)
          if(force_show_modal.length){
            let a = force_show_modal.shift();
            //setRead(a.entity_id);
            let l = JSON.parse(localStorage.getItem("Elite:ignoreNotification")??"[]");
            l.push(a.notification_id);
            localStorage.setItem("Elite:ignoreNotification",JSON.stringify(l));
            set_force_show_modal([...force_show_modal])
          }
        }}
        header={
          <Row style={{fontWeight:"bold"}}>
            <Col className="card-tab-title">{title}</Col>
            {force_show_modal.length==0?(
              <Col xs="auto" style={{color:"#fd6853"}}>
                {load?<></>:(
                  <>
                    <KeyboardArrowLeft className={'card-tab-side'+(n<=0?" disabled":"")} onClick={()=>{
                      if(n > 0){
                        set_n(n-1);
                      }
                    }}/>
                    <label style={{fontSize: "small",fontWeight: "500"}}>{` ${n+1}/${list.length} `}</label>
                    <KeyboardArrowRight className={'card-tab-side'+(n>=list.length-1?" disabled":"")} onClick={()=>{
                      if(n < list.length-1){
                        set_n(n+1)
                      }
                    }}/>
                  </>
                )}
              </Col>
            ):<></>}
          </Row>
        }
        body={
          <div style={{width: '100%',overflow:"hidden"}}>
            <div style={{width: `calc(100% * ${list.length})`, marginLeft: `calc(-100% * ${n})`, transition:(enable_transition?".3s":"")}}>
              {(force_show_modal.length?[force_show_modal[0]]:list).map((item, key)=>{
                return (
                  <div key={key} style={{display:"inline-block",width: `calc(100% / ${list.length})`, padding:`0 2rem 0 2rem`,verticalAlign:"top"}}>
                    <div style={{color: "#595959",fontWeight: "600"}}>{item.title}</div>
                    <div style={{color: "#595959"}}>{item.content}</div>
                    <Row className="justify-content-between">
                      <Col xs="auto">
                        {item.tag?
                        <MyBadges variant={(item.tag.variant??"primary")}>{item.tag.text}</MyBadges>
                        :<></>}
                      </Col>
                      <Col xs="auto">
                        {/* <div className="card-tab-item-slide-more">Saiba mais <ArrowRightSharp/></div> */}
                      </Col>
                    </Row>
                    
                  </div>
                )
              })}
            </div>
          </div>
        }
      />
    </>
  )
}